import React from 'react';
import Navigation from "../components/Navigation";
import Content from "../components/Content";

const AdminListingOfficerLayout = ({user, role, modules}) => {
  return (
    <div className="d-flex" id="wrapper">
      <div id="view-wrapper">
        <Navigation
          displayName={user.attributes['custom:display_name']}
          email={user.attributes['email']}
          role={role}
          entity={"PDS"}
          modules={modules}/>
        <Content modules={modules} />
      </div>
    </div>
  );
}

export default AdminListingOfficerLayout;




